import { useState, useEffect, useCallback, useMemo } from 'react';

import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import 'moment/locale/pt-br';

import { Stack, Button, Box, Tooltip, IconButton, TextField } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';

import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import DataList from '../../form/DataList';
import Input from '../../form/Input';
import InputFloat from '../../form/InputFloat';
import InputNumber from '../../form/InputNumber';
import Select from '../../form/Select';
import SelectEmpresa from '../../form/SelectEmpresa';
import Checkbox from '../../form/Checkbox';

import formStyles from '../../form/Form.module.css';
import { formatarNumero, formatarNumeroDecimal, limitarTexto, maskCEP, maskDecimal } from '../../../utils/masks';
/* api */
import * as DataListAPI from '../../../api/dataList';
import * as EmpresaAPI from '../../../api/empresa';
import * as ParametroAPI from '../../../api/parametro';
import * as SituacaoAPI from '../../../api/situacao';
import * as TabelaAPI from '../../../api/tabela';

import { podeEditar, podeIncluir, podeEditarItem, podeCancelarItem } from '../../../hooks/usePermisionMRT';
import { useMRTState } from '../../../hooks/useMRTState';

function Form({
    dados,
    setDados,
    //tabelas filhas
    pessoa,
    setPessoa,
    handleSubmit,
    btnText,
    caminhoVoltar,
    OptionsEmpresa,
    OptionsConta,
    OptionsForma,
    OptionsPrazo,
    optionsUnidade,
    OptionsOperacao,
    OptionsPlantaoTipo,
    empresaId,
    empresaIds,
    empresaTabelaId,
    //serviços
    ncmImovel,
    setNcmImovel,
    ncmServico,
    setNcmServico,
}) {
    const [parametroOperacaoCustos, setParametroOperacaoCustos] = useState([]);

    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: urlParams.get('tipo'),
        //operacao: operacaoUUID,
        //uuid: uuid,
        btnText: urlParams.get('btnText'),
    });

    const expedienteMrt = useMRTState({
        storageKey: 'parametro.expediente',
        initialState: {
            columnFilterFns: {},
            columnFilters: [],
            globalFilter: '',
            sorting: [],
            pagination: {
                pageIndex: 0,
                pageSize: 10,
            },
        },
    });
    const custoMrt = useMRTState({
        storageKey: 'parametro.operacaoCusto',
        initialState: {
            columnFilterFns: {},
            columnFilters: [],
            globalFilter: '',
            sorting: [],
            pagination: {
                pageIndex: 0,
                pageSize: 5,
            },
        },
    });

    //abas
    const [tabEnabled, setTabEnabled] = useState({});

    //situação para submeter o formulario e evitar vários clicks
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);

    //set datalist
    const [OptionsParceiro, setOptionsParceiro] = useState([]);

    const [OptionsNcmBobina, setOptionsNcmBobina] = useState([]);
    const [ncmBobina, setNcmBobina] = useState(dados?.ncmBobina || {});
    const [OptionsNcmServico, setOptionsNcmServico] = useState([]);
    const [OptionsNcmImovel, setOptionsNcmImovel] = useState([]);

    const [optionsSituacao, setOptionsSituacao] = useState([]);
    const [optionsSituacaoHomologationPessoa, setSituacaoHomologationPessoa] = useState([]);
    const [optionsSituacaoHomologationItem, setSituacaoHomologationItem] = useState([]);

    const consultaDatalist = async (params) => {
        try {
            return await DataListAPI.dataList(params);
        } catch (error) {
            console.error('Erro ao consultar DataList:', error);
            throw error;
        }
    };

    const consultaSituacao = async (tabela) => {
        try {
            const result = await SituacaoAPI.situacoes(empresaTabelaId);

            if (tabela === 'homologation') {
                const filtrado = result?.filter((item) => item.homologation === true) || [];
                setOptionsSituacao(filtrado);
            }
            if (tabela === 'homologationPessoa') {
                const filtrado = result?.filter((item) => item.homologationPessoa === true) || [];
                setSituacaoHomologationPessoa(filtrado);
            }
            if (tabela === 'homologationItem') {
                const filtrado = result?.filter((item) => item.homologationItem === true) || [];
                setSituacaoHomologationItem(filtrado);
            }
        } catch (error) {
            console.error(error);
        }
    };

    //options dos selects
    const [OptionsTRF, setTRF] = useState([]); //centros de custos de transferencias entre contas
    const [OptionsCCI, setCCI] = useState([]); //centro de custos da industria
    const [OptionsCCR, setCCR] = useState([]); //centro de custos de receitas
    const [OptionsCCP, setCCP] = useState([]); //centros de custos de despesas
    const [OptionsCCLIM, setCCLIM] = useState([]); //centros de custos de locação de imoaveis
    const [OptionsPosition, setOptionsPosition] = useState([]);
    const [OptionsTema, setOptionsTema] = useState([]);
    const [OptionsMoedaEstrangeira, setOptionsMoedaEstrangeira] = useState([]);

    //variaveis da grid
    const [novoExpediente, setNovoExpediente] = useState({
        diaSemana: 0,
        ativo: true,
        inicio: '08:00:00',
        termino: '18:00:00',
        descontaIntervalo: true,
        intervaloInicio: '12:00:00',
        intervaloTermino: '13:00:00',
        funcao: 'Editar',
    });
    const [novaOperacaoCusto, setNovaOperacaoCusto] = useState({});

    //opções de paginação
    const OptionsPaginacao = [
        { id: '5', descricao: '5' },
        { id: '10', descricao: '10' },
        { id: '15', descricao: '15' },
        { id: '20', descricao: '20' },
        { id: '25', descricao: '25' },
        { id: '30', descricao: '30' },
        { id: '50', descricao: '50' },
        { id: '100', descricao: '100' },
    ];

    //consulta backend
    const consultaCC = useCallback(
        async (
            descricao = null,
            tipo = null,
            combustivel = null,
            manutencao = null,
            industria = null,
            option = null,
            servico = null
        ) => {
            const dado = await EmpresaAPI.centroCustos(
                dados.empresaId,
                descricao,
                tipo,
                combustivel,
                manutencao,
                industria,
                servico
            );

            if (tipo === 'Receber') {
                setCCR(dado);
            }
            if (tipo === 'Pagar') {
                setCCP(dado);
            }
            if (tipo === 'Ambos') {
                setTRF(dado);
            }
            if (industria === true) {
                setCCI(dado);
            }
            if (servico === true) {
                setCCLIM(dado);
            }

            return dado;
        },
        [dados.empresaId, setCCR, setCCP, setTRF, setCCI, setCCLIM]
    );
    const consultaEnum = async (tabela, campo, setEnum) => {
        const result = await TabelaAPI.enums(tabela, campo);
        if (setEnum === 'OptionsPosition') {
            setOptionsPosition(result ? result : []);
        } else if (setEnum === 'OptionsTema') {
            setOptionsTema(result ? result : []);
        } else if (setEnum === 'OptionsMoedaEstrangeira') {
            setOptionsMoedaEstrangeira(result ? result : []);
        }
    };

    useEffect(() => {
        setPessoa(dados?.pessoaPadrao || {});
        setParametroOperacaoCustos(dados?.parametroOperacaoCustos || []);
        setNcmBobina(dados?.ncmBobina || {});
        setNcmImovel(dados?.ncmImovel || {});
        setNcmServico(dados?.ncmServico || {});
    }, []);
    useEffect(() => {
        consultaCC('', 'Ambos', false, false, false); //Receitas
        consultaCC('', 'Receber', false, false, false); //Receitas
        consultaCC('', 'Pagar', false, false, false); //Despesas
        consultaCC('', '', false, false, true, false, false); // Industria
        consultaCC('', '', false, false, false, false, true); // Serviço

        //carrega enums
        consultaEnum('Parametros', 'msgPosition', 'OptionsPosition');
        consultaEnum('Parametros', 'tema', 'OptionsTema');
        consultaEnum('Parametros', 'moedaEstrangeira', 'OptionsMoedaEstrangeira');

        consultaSituacao('homologation');
        consultaSituacao('homologationItem');
        consultaSituacao('homologationPessoa');

        setNovaOperacaoCusto({
            id: null,
            uuid: null,

            parametroId: dados.id,
            operacaoId: null,
            plantaoTipoId: null,

            custo: true,
            receita: false,
            ativo: true,
            funcao: 'Adicionar',
        });
    }, [consultaCC]);

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        custoMrt.columnFilterFns,
        custoMrt.columnFilters,
        custoMrt.globalFilter,
        custoMrt.pagination.pageIndex,
        custoMrt.pagination.pageSize,
        custoMrt.sorting,
    ]);
    useEffect(() => {
        fetchExpediente();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expedienteMrt.columnFilterFns,
        expedienteMrt.columnFilters,
        expedienteMrt.globalFilter,
        expedienteMrt.pagination.pageIndex,
        expedienteMrt.pagination.pageSize,
        expedienteMrt.sorting,
    ]);
    async function handleChange(e) {
        const { name, value, checked, type } = e.target;

        const camposMonetarios = [
            'horaExtraPercentual',
            'horaExtraEspecialPercentual',
            'adicionalNoturnoPercentual',
            'adicionalNoturnoEspecialPercentual',
        ];
        if (camposMonetarios.includes(name)) {
            const valorFormatado = formatarNumeroDecimal(value);
            setDados({
                ...dados,
                [name]: valorFormatado,
            });
        } else if (name === 'centroCustoMateriaPrimaId') {
            setDados({
                ...dados,
                [name]: value,
            });
        } else if (name.startsWith('Pessoa.')) {
            setPessoa({
                ...pessoa,
                [name.split('.')[1]]: value,
            });

            //consulta datalist
            const result = await consultaDatalist({
                empresaId: dados.empresaId,
                tabela: 'Pessoa',
                condicao: tipo,
                filtro: value,
            });
            setOptionsParceiro(result);

            const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id;

            setDados((prevState) => ({
                ...prevState,
                pessoaId: selectedId ?? null,
            }));
        } else if (name.startsWith('ncmBobina.')) {
            setNcmBobina({
                ...ncmBobina,
                [name.split('.')[1]]: value,
            });

            //consulta datalist
            const result = await consultaDatalist({
                empresaId: empresaTabelaId,
                tabela: 'NCM',
                filtro: value,
            });
            setOptionsNcmBobina(result);

            const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id;

            setDados((prevState) => ({
                ...prevState,
                ncmIdBobina: selectedId ?? null,
            }));
        } else if (name.startsWith('ncmImovel.')) {
            setNcmImovel({
                ...ncmImovel,
                [name.split('.')[1]]: value,
            });

            //consulta datalist
            const result = await consultaDatalist({
                empresaId: empresaTabelaId,
                tabela: 'NCM',
                filtro: value,
            });
            setOptionsNcmImovel(result);

            const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id;

            setDados((prevState) => ({
                ...prevState,
                ncmIdImovel: selectedId ?? null,
            }));
        } else if (name.startsWith('ncmServico.')) {
            setNcmServico({
                ...ncmServico,
                [name.split('.')[1]]: value,
            });

            //consulta datalist
            const result = await consultaDatalist({
                empresaId: empresaTabelaId,
                tabela: 'NCM',
                filtro: value,
            });
            setOptionsNcmServico(result);

            const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id;

            setDados((prevState) => ({
                ...prevState,
                ncmIdServico: selectedId ?? null,
            }));
        } else if (name.startsWith('novaOperacaoCusto.')) {
            setNovaOperacaoCusto({ ...novaOperacaoCusto, [name.split('.')[1]]: type === 'checkbox' ? checked : value });
        } else if (name.startsWith('novoExpediente.')) {
            setNovoExpediente((prev) => ({
                ...prev,
                [name.split('.')[1]]: type === 'checkbox' ? checked : value,
            }));
        } else {
            setDados((prev) => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value,
            }));
        }
    }
    async function handleOnBlur(e) {}
    async function handleOnFocus(e) {}

    const submit = async (e) => {
        e.preventDefault();

        if (isSubmitting) return;

        setIsSubmitting(true);

        try {
            await handleSubmit(dados);
        } finally {
            setIsSubmitting(false);
        }
    };

    //objetos de grids
    const fetchData = useCallback(async () => {
        if (!parametroOperacaoCustos?.length) {
            custoMrt.setIsLoading(true);
        } else {
            custoMrt.setIsRefetching(true);
        }

        try {
            const response = await ParametroAPI.listarOperacoesCustos({
                start: custoMrt.pagination.pageIndex * custoMrt.pagination.pageSize,
                size: custoMrt.pagination.pageSize,
                filters: JSON.stringify(custoMrt.columnFilters ?? []),
                filtersMode: JSON.stringify(custoMrt.columnFilterFns ?? []),
                globalFilter: custoMrt.globalFilter ?? '',
                sorting: JSON.stringify(custoMrt.sorting ?? []),
                parametroId: dados.id,
            });

            setParametroOperacaoCustos(response?.data?.data ?? []);
            custoMrt.setRowCount(response?.data?.meta?.totalRowCount ?? 0);
        } catch (error) {
            custoMrt.setIsError(true);
            console.error(error);
            return;
        }

        custoMrt.setIsError(false);
        custoMrt.setIsLoading(false);
        custoMrt.setIsRefetching(false);
    });
    const fetchExpediente = useCallback(async () => {
        if (!dados.id) return;

        try {
            expedienteMrt.setIsLoading(true);

            const response = await ParametroAPI.listarExpediente({
                start: expedienteMrt.pagination.pageIndex * expedienteMrt.pagination.pageSize,
                size: expedienteMrt.pagination.pageSize,
                filters: JSON.stringify(expedienteMrt.columnFilters ?? []),
                filtersMode: JSON.stringify(expedienteMrt.columnFilterFns ?? []),
                globalFilter: expedienteMrt.globalFilter ?? '',
                sorting: JSON.stringify(expedienteMrt.sorting ?? []),
                parametroId: dados.id,
            });

            setDados((prev) => ({
                ...prev,
                expedientes: response?.data?.data ?? [],
            }));

            expedienteMrt.setRowCount(response?.data?.meta?.totalRowCount ?? 0);
            expedienteMrt.setIsError(false);
        } catch (error) {
            expedienteMrt.setIsError(true);
            console.error(error);
        } finally {
            expedienteMrt.setIsLoading(false);
            expedienteMrt.setIsRefetching(false);
        }
    }, [
        dados.id,
        expedienteMrt.pagination.pageIndex,
        expedienteMrt.pagination.pageSize,
        expedienteMrt.columnFilters,
        expedienteMrt.columnFilterFns,
        expedienteMrt.globalFilter,
        expedienteMrt.sorting,
    ]);

    const handleLimpar = async (obj) => {
        if (obj === 'custo') {
            setNovaOperacaoCusto({
                id: null,
                uuid: null,

                parametroId: dados.id,
                operacaoId: null,
                plantaoTipoId: null,

                custo: true,
                receita: false,
                ativo: true,
                funcao: 'Adicionar',
            });
            await fetchData(obj);
        }
        if (obj === 'expediente') {
            setNovoExpediente({
                diaSemana: '',
                ativo: true,
                inicio: '08:00:00',
                termino: '18:00:00',
                descontaIntervalo: true,
                intervaloInicio: '12:00:00',
                intervaloTermino: '13:00:00',
                funcao: 'Editar',
            });
            await fetchExpediente();
            return;
        }
    };

    const handleObjeto = async (obj) => {
        if (obj === 'expediente') {
            try {
                const result = await ParametroAPI.managerExpediente(novoExpediente);
                setFlashMessage(result.data.message, result.data.type);
                //limpa e atualiza a grid
                handleLimpar(obj);
            } catch (error) {
                console.error(error);
            }
        }
        if (obj === 'custo') {
            if (novaOperacaoCusto.funcao.toLowerCase() === 'editar') {
                if (novaOperacaoCusto.uuid) {
                    try {
                        //verificar duplicidade
                        const result = await ParametroAPI.duplicidadeOperacaoCusto({
                            parametroId: novaOperacaoCusto.parametroId,
                            operacaoId: novaOperacaoCusto.operacaoId,
                            plantaoTipoId: novaOperacaoCusto.plantaoTipoId,
                            uuid: novaOperacaoCusto.uuid,
                        });

                        if (result) {
                            setFlashMessage('Registo em duplicidade!', 'warning');
                            handleItem(result, null, 'Editar', obj);
                            return;
                        }

                        await CreateOrEditObjeto(novaOperacaoCusto, obj);
                    } catch (error) {
                        console.error(error);
                    }
                } else {
                    setParametroOperacaoCustos([...parametroOperacaoCustos, novaOperacaoCusto]);
                }
            } else if (novaOperacaoCusto.funcao.toLowerCase() === 'cancelar') {
                try {
                    const response = await ParametroAPI.deletarOperacaoCusto(novaOperacaoCusto.uuid);
                    setFlashMessage(response.data.message, response.data.type);
                } catch (error) {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                }
            } else {
                //cadastrar
                try {
                    //verificar duplicidade
                    const result = await ParametroAPI.duplicidadeOperacaoCusto({
                        parametroId: novaOperacaoCusto.parametroId,
                        operacaoId: novaOperacaoCusto.operacaoId,
                        plantaoTipoId: novaOperacaoCusto.plantaoTipoId,
                    });

                    if (result.status === 422) {
                        setFlashMessage('Erro de validação: ' + result?.response?.data?.message, 'error');
                        return;
                    }
                    if (result && novaOperacaoCusto.funcao.toLowerCase() === 'adicionar') {
                        setFlashMessage('Registo em duplicidade!', 'warning');
                        handleItem(result, null, 'Adicionar');
                        return;
                    }
                    await CreateOrEditObjeto(novaOperacaoCusto, obj);
                } catch (error) {
                    console.error(error);
                }
            }

            handleLimpar(obj);
        }
    };
    const CreateOrEditObjeto = async (novaOperacaoCusto, obj) => {
        try {
            const result = await ParametroAPI.CreateOrEditOperacaoCusto(novaOperacaoCusto);
            setFlashMessage(result.data.message, result.data.type);
            //limpa e atualiza a grid
            handleLimpar(obj);
        } catch (error) {
            console.error(error);
            if (error.response && error.response.status === 422) {
                // Tratar o erro 422, que é específico da validação no servidor
                setFlashMessage('Erro de validação: ' + error.response.data.message, 'error');
            } else {
                // Tratar outros erros de rede ou servidor
                setFlashMessage('Ocorreu um erro ao processar a solicitação.', 'error');
            }
        }
    };
    const handleItem = async (originalRow, row, funcao, obj) => {
        if (obj === 'expediente') {
            const newData = {
                id: originalRow.id,
                parametroId: originalRow.parametroId,
                diaSemana:
                    originalRow.diaSemana === null || originalRow.diaSemana === undefined ? '' : String(originalRow.diaSemana),

                inicio: originalRow.inicio,
                termino: originalRow.termino,
                descontaIntervalo: originalRow.descontaIntervalo,
                intervaloInicio: originalRow.intervaloInicio,
                intervaloTermino: originalRow.intervaloTermino,
                ativo: originalRow.ativo,

                funcao: funcao,
                index: row,
            };

            // Atualize o estado do novo produto
            setNovoExpediente(newData);
        }
        if (obj === 'custo') {
            const newData = {
                id: originalRow.id,
                uuid: originalRow.uuid,
                parametroId: originalRow.parametroId,
                operacaoId: originalRow.operacaoId,
                plantaoTipoId: originalRow.plantaoTipoId,
                custo: originalRow.custo,
                receita: originalRow.receita,
                ativo: originalRow.ativo,

                funcao: funcao,
                index: row,
            };

            // Atualize o estado do novo produto
            setNovaOperacaoCusto(newData);
        }
    };

    const diasSemanaOptions = [
        { label: 'Todos', value: '' },
        { label: 'Domingo', value: '0' },
        { label: 'Segunda', value: '1' },
        { label: 'Terça', value: '2' },
        { label: 'Quarta', value: '3' },
        { label: 'Quinta', value: '4' },
        { label: 'Sexta', value: '5' },
        { label: 'Sábado', value: '6' },
    ];

    const nomeDiaSemana = {
        0: 'Domingo',
        1: 'Segunda',
        2: 'Terça',
        3: 'Quarta',
        4: 'Quinta',
        5: 'Sexta',
        6: 'Sábado',
    };
    const columnsExpediente = useMemo(
        () => [
            {
                id: 'expedientes',
                header: 'Expediente semanal',
                columns: [
                    {
                        accessorKey: 'diaSemana',
                        header: 'Dia',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: diasSemanaOptions,
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = Number(row.original.diaSemana);
                            return <div>{nomeDiaSemana[value] ?? value}</div>;
                        },
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'inicio',
                        header: 'Início',
                        Cell: ({ cell }) => String(cell.getValue() || '').slice(0, 5),
                    },
                    {
                        accessorKey: 'termino',
                        header: 'Término',
                        Cell: ({ cell }) => String(cell.getValue() || '').slice(0, 5),
                    },
                    {
                        accessorKey: 'descontaIntervalo',
                        header: 'Desc. Intervalo',
                        filterVariant: 'select',
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        Cell: ({ row }) => <div>{row.original.descontaIntervalo ? 'Sim' : 'Não'}</div>,
                    },
                    {
                        accessorKey: 'intervaloInicio',
                        header: 'Int. Início',
                        Cell: ({ cell }) => String(cell.getValue() || '').slice(0, 5),
                    },
                    {
                        accessorKey: 'intervaloTermino',
                        header: 'Int. Término',
                        Cell: ({ cell }) => String(cell.getValue() || '').slice(0, 5),
                    },
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        filterVariant: 'select',
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        Cell: ({ row }) => <div>{row.original.ativo ? 'Sim' : 'Não'}</div>,
                    },
                ],
            },
        ],
        []
    );
    const columnsCusto = useMemo(
        () => [
            {
                id: 'custos',
                header: `Operações vinculadas aos custos do plantão`,
                columns: [
                    {
                        accessorKey: 'plantaoTipo.descricao',
                        header: 'Plantão tipo',
                        muiTableBodyCellProps: {
                            align: 'left',
                        },
                    },
                    {
                        accessorKey: 'Operacao.descricao',
                        header: 'Operação',
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {},
                            align: 'left',
                        }),
                    },
                    {
                        accessorKey: 'custo',
                        header: 'Custo',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.custo;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'receita',
                        header: 'Receita',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.receita;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.ativo;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [] //getCommonEditTextFieldProps
    );

    const theme = tableThemeCustom();
    return (
        <div>
            <Tabs>
                <form onSubmit={submit}>
                    <h1>Parâmetros</h1>
                    <TabList>
                        <Tab title={'Parâmetros Básicos'}>Básico</Tab>
                        <Tab title={'Parâmetros da Indústria'}>Indústria</Tab>
                        <Tab title={'Parâmetros Financeiros'}>Financeiro</Tab>
                        <Tab title={'Parâmetros de Movimentações de Entradas'}>Entradas</Tab>
                        <Tab title={'Parâmetros de Movimentações de Saídas'}>Saídas</Tab>
                        <Tab title={'Parâmetros de Movimentações de Serviço'}>Serviço</Tab>
                        <Tab title={'Parâmetros de Custos'}>Custo</Tab>
                    </TabList>
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros básicos da empresa</h4>
                            <div>
                                <div>
                                    <SelectEmpresa
                                        text="Selecione a Empresa"
                                        name="empresaId"
                                        options={OptionsEmpresa}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={dados.empresaId || ''}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Configurações de Tela</h4>
                            <div>
                                <Input
                                    text="Altura"
                                    type="number"
                                    name="logomarcaAltura"
                                    placeholder="Altura"
                                    inputWidth="100px"
                                    title="configura a altura da logomarca da empresa"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.logomarcaAltura || 80}
                                    textAlign="center"
                                    min={5}
                                />
                                <Input
                                    text="Largura"
                                    type="number"
                                    name="logomarcaLargura"
                                    placeholder="Largura"
                                    inputWidth="100px"
                                    title="configura a largura da logomarca da empresa"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.logomarcaLargura || 80}
                                    textAlign="center"
                                    min={5}
                                />
                                <Input
                                    text="Tempo"
                                    type="range"
                                    name="msgTempo"
                                    inputWidth="100px"
                                    title="configura o tempo de exposição da mensgem em segundos"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.msgTempo}
                                    textAlign="center"
                                    min={1}
                                    max={5}
                                />
                                <Select
                                    name="msgPosition"
                                    title="Selecione a posição da mensagem"
                                    text="Posição"
                                    inputWidth="150px"
                                    options={OptionsPosition}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.msgPosition}
                                    isEnum={true}
                                    notOptNull={true}
                                    required={true}
                                />
                                <Checkbox
                                    title="Utiliza cores padrão do sistema ou o usuário configura"
                                    text="Cores padrão"
                                    name="msgCoresDefault"
                                    handleOnChange={handleChange}
                                    value={dados.msgCoresDefault}
                                    checked={!!dados.msgCoresDefault}
                                />
                                <Input
                                    text="BackGround-Color"
                                    type="color"
                                    name="msgBackgroundColor"
                                    title="configura a cor de fundo da mensagem"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.msgBackgroundColor ?? '#ffe7e7'}
                                />
                                <Input
                                    text="Text-Color"
                                    type="color"
                                    name="msgTextColor"
                                    title="configura a cor do texto da mensagem"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.msgTextColor ?? '#155724'}
                                />
                                <Select
                                    name="tema"
                                    title="Selecione o tema"
                                    text="Tema"
                                    inputWidth="150px"
                                    options={OptionsTema}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.tema}
                                    isEnum={true}
                                    notOptNull={true}
                                    required={true}
                                />
                            </div>
                            <div>
                                <InputFloat
                                    text="Latitude"
                                    type="text"
                                    name="latitude"
                                    placeholder="Latitude"
                                    inputWidth="140px"
                                    title="Informa a latitude da empresa"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.latitude}
                                    textAlign={'right'}
                                />
                                <InputFloat
                                    text="Longitude"
                                    type="text"
                                    name="longitude"
                                    placeholder="Longitude"
                                    inputWidth="140px"
                                    title="Informa a longitude da empresa"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.longitude}
                                    textAlign={'right'}
                                />
                                <Input
                                    text="Zoom"
                                    type="number"
                                    name="zoom"
                                    placeholder="Zoom"
                                    inputWidth="100px"
                                    title="configura a aproximação padrão de abertura do mapa"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.zoom}
                                    textAlign="center"
                                    min={1}
                                />
                                <Input
                                    text="Paginação"
                                    type="number"
                                    name="paginacao"
                                    inputWidth="100px"
                                    title="define a quantidade de linhas por pagina da grid, o valor deverá existir na Lista de Paginação"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.paginacao}
                                    textAlign="center"
                                    min={5}
                                />
                                <Input
                                    name="paginacaoOptions"
                                    title="define as opções de paginações da grid, os números devem ser separados por virgula (,)"
                                    text="Lista de Paginação"
                                    inputWidth="250px"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.paginacaoOptions}
                                />
                            </div>
                            <div>
                                <Checkbox
                                    title="O sistema possui várias tabelas comuns, que são Bancos, CFOP, NCM, etc..,
                            ao desmarcar a opção, indica que as tabelas consideradas comuns precisam ser alimentadas
                            pela empresa. Por padrão deve deixar essa opção marcada para usar as tabelas existentes no sistema."
                                    text="Tabelas Comuns"
                                    name="tabelasComuns"
                                    handleOnChange={handleChange}
                                    value={dados.tabelasComuns}
                                    checked={!!dados.tabelasComuns}
                                />
                                <DataList
                                    title="Pessoa que será colocada nos movimentos, financeiro, industria como padrão"
                                    text="Selecione a Pessoa Padrão"
                                    name="Pessoa.nomePrincipal"
                                    inputWidth="350px"
                                    filteredOptions={OptionsParceiro}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={pessoa.nomePrincipal || ''}
                                />
                            </div>
                            <div>
                                <Select
                                    name="situacaoHomologacaoId"
                                    title="Situação / status padrão da homologação"
                                    text="Homologação"
                                    inputWidth="150px"
                                    options={optionsSituacao}
                                    handleOnChange={handleChange}
                                    value={dados.situacaoHomologacaoId}
                                    notOptNull={false}
                                />
                                <Select
                                    name="situacaoHomologacaoItemId"
                                    title="Situação padrão do item da homologação"
                                    text="Homologação Item"
                                    inputWidth="150px"
                                    options={optionsSituacaoHomologationItem}
                                    handleOnChange={handleChange}
                                    value={dados.situacaoHomologacaoItemId}
                                    notOptNull={false}
                                />
                                <Select
                                    name="situacaoHomologacaoPessoaId"
                                    title="Responsável padrão da homologação"
                                    text="Homologação Responsável"
                                    inputWidth="150px"
                                    options={optionsSituacaoHomologationPessoa}
                                    handleOnChange={handleChange}
                                    value={dados.situacaoHomologacaoPessoaId}
                                    notOptNull={false}
                                />
                                <Select
                                    name="situacaoHomologacaoUserId"
                                    title="Usuário padrão da homologação"
                                    text="Homologação Usuário"
                                    inputWidth="150px"
                                    options={optionsSituacaoHomologationPessoa}
                                    handleOnChange={handleChange}
                                    value={dados.situacaoHomologacaoUserId}
                                    notOptNull={false}
                                />
                            </div>
                            <div className={formStyles.stiloPadrao}>
                                <h4>Cadastro rápido de produtos</h4>

                                <div>
                                    <Checkbox
                                        title="Define se os produtos criados pelo cadastro rápido ficarão disponíveis para venda por padrão"
                                        text="Disponível para venda"
                                        name="produtoCadastroRapidoVendaPadrao"
                                        handleOnChange={handleChange}
                                        value={dados.produtoCadastroRapidoVendaPadrao}
                                        checked={!!dados.produtoCadastroRapidoVendaPadrao}
                                    />

                                    <Checkbox
                                        title="Define se os produtos criados pelo cadastro rápido serão considerados matéria-prima por padrão"
                                        text="Matéria-prima"
                                        name="produtoCadastroRapidoMateriaPrimaPadrao"
                                        handleOnChange={handleChange}
                                        value={dados.produtoCadastroRapidoMateriaPrimaPadrao}
                                        checked={!!dados.produtoCadastroRapidoMateriaPrimaPadrao}
                                    />
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros para o modulo de indústria</h4>

                            <div>
                                <Checkbox
                                    title="Informa se a empresa utiliza plantões na produção"
                                    text="Plantão"
                                    name="plantao"
                                    handleOnChange={handleChange}
                                    value={dados.plantao}
                                    checked={!!dados.plantao}
                                />
                                <Checkbox
                                    title="Informa se a entrada de matéria-prima estoca no almoxarifado de grãos"
                                    text="MP Est Grãos"
                                    name="materiaPrimaEstocaGraos"
                                    handleOnChange={handleChange}
                                    value={dados.materiaPrimaEstocaGraos}
                                    checked={!!dados.materiaPrimaEstocaGraos}
                                />
                                <Select
                                    name="centroCustoMateriaPrimaId"
                                    title={'Define o centro de custo padrão para entrada de matéria-prima'}
                                    text="Centro Custo MP"
                                    options={OptionsCCI}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.centroCustoMateriaPrimaId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Checkbox
                                    title="Informa se o refugo vai gerar valor a receber no modulo financeiro"
                                    text="Refugo MP gera financeiro"
                                    name="refugoMateriaPrimaGeraFinanceiro"
                                    handleOnChange={handleChange}
                                    value={dados.refugoMateriaPrimaGeraFinanceiro}
                                    checked={!!dados.refugoMateriaPrimaGeraFinanceiro}
                                />
                                <Select
                                    name="centroCustoRefugoMateriaPrimaId"
                                    title={'Define o centro de custo padrão para o refugo da matéria-prima'}
                                    text="Centro Custo Refugo"
                                    options={OptionsCCI}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.centroCustoRefugoMateriaPrimaId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                            </div>
                            <div>
                                <DataList
                                    title="NCM padrão para bobina"
                                    text="NCM Bobina"
                                    name="ncmBobina.ncm"
                                    inputWidth="350px"
                                    filteredOptions={OptionsNcmBobina}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={ncmBobina.ncm || ''}
                                />
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros de Comuns</h4>
                            <TextField
                                size="small"
                                name="condominioDiaVencimentoPadrao"
                                label="Dia padrão do condomínio"
                                value={dados?.condominioDiaVencimentoPadrao ?? ''}
                                onChange={handleChange}
                                helperText="Informe de 1 a 31 para unidades sem dia cadastrado. Vazio deixa o vencimento pendente quando a unidade também não tem dia."
                                title="Informe de 1 a 31 para unidades sem dia cadastrado. Vazio deixa o vencimento pendente quando a unidade também não tem dia."
                                inputProps={{ inputMode: 'numeric' }}
                                sx={{ width: 300, maxWidth: '100%' }}
                            />
                            <div>
                                <Select
                                    name="centroCustoTransferencia"
                                    title={'Define o centro de custo padrão para os transferências entre contas'}
                                    text="Centro Custo Transferências"
                                    inputWidth="200px"
                                    options={OptionsTRF}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.centroCustoTransferencia}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="transferenciaForma"
                                    title={'Define a forma padrão para os transferências entre contas'}
                                    text="Forma Transferências"
                                    inputWidth="200px"
                                    options={OptionsForma}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.transferenciaForma}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="transferenciaPrazo"
                                    title={
                                        'Define o prazo padrão para os transferências entre contas, como também o prazo a vista utilizado no sistema'
                                    }
                                    text="Prazo Transferências / A Vista"
                                    inputWidth="200px"
                                    options={OptionsPrazo}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.transferenciaPrazo}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Checkbox
                                    title="Permite calcular juros e multa"
                                    text="Calcula Juros"
                                    name="calculaJuros"
                                    handleOnChange={handleChange}
                                    value={dados.calculaJuros}
                                    checked={!!dados.calculaJuros}
                                />
                            </div>
                            <div>
                                <Select
                                    name="contaId"
                                    title={'Define a conta padrão para lançamentos'}
                                    text="Conta"
                                    inputWidth="200px"
                                    options={OptionsConta}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.contaId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                            </div>
                            <div>
                                <Select
                                    name="moedaEstrangeira"
                                    title="Selecione a moeda estrangeira padrão"
                                    text="Moeda Estrangeira"
                                    inputWidth="150px"
                                    options={OptionsMoedaEstrangeira}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.moedaEstrangeira}
                                    isEnum={true}
                                    notOptNull={true}
                                    required={true}
                                />
                                <Select
                                    name="centroCustoComissaoId"
                                    title={'Define o centro de custo padrão para as comissões'}
                                    text="Centro Custo Comissão"
                                    inputWidth="200px"
                                    options={OptionsCCP}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.centroCustoComissaoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                            </div>
                            <div>
                                <Checkbox
                                    title="permite que seja utilizado o sub centro de custo, um segundo sentro de custo para os lançamentos"
                                    text="subCentroCusto"
                                    name="usaSubCentroCusto"
                                    handleOnChange={handleChange}
                                    value={dados.usaSubCentroCusto}
                                    checked={!!dados.usaSubCentroCusto}
                                />
                                <Checkbox
                                    title="permite emitir recibo em impressora térmica"
                                    text="Recibo 80 colunas"
                                    name="recibo80Col"
                                    handleOnChange={handleChange}
                                    value={dados.recibo80Col}
                                    checked={!!dados.recibo80Col}
                                />
                                <Checkbox
                                    title="em sistemas multi empresa, desvincula ao selecionar a empresa a captura das contas vinculadas a empresa selecionada"
                                    text="Mistura Contas"
                                    name="multiEmpresaContas"
                                    handleOnChange={handleChange}
                                    value={dados.multiEmpresaContas}
                                    checked={!!dados.multiEmpresaContas}
                                />
                            </div>
                            <div>
                                <Input
                                    text="balanceteAnos"
                                    type="number"
                                    name="Balancete Anos"
                                    placeholder="Anos"
                                    inputWidth="100px"
                                    title="configura a quantidade de anos a ser comparada no balancete financeiro, mínimo de 2 anos e máximo de 10 anos"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.balanceteAnos}
                                    textAlign="center"
                                    min={2}
                                    max={10}
                                    readOnly={false}
                                />
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros de movimentações de entradas</h4>
                            <div>
                                <Select
                                    name="centroCustoPDC"
                                    title={'Define o centro de custo padrão para operações de Compras'}
                                    text="Centro Custo Compras"
                                    inputWidth="200px"
                                    options={OptionsCCP}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.centroCustoPDC}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="unidadeEntradaId"
                                    title={'Define a unidade padrão de entrada'}
                                    text="Unidade Entrada"
                                    inputWidth="200px"
                                    options={optionsUnidade}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.unidadeEntradaId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros de movimentações de saídas</h4>
                            <div>
                                <Select
                                    name="centroCustoPDV"
                                    title={'Define o centro de custo padrão para operações de Vendas'}
                                    text="Centro Custo Vendas"
                                    inputWidth="200px"
                                    options={OptionsCCR}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.centroCustoPDV}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="unidadeSaidaId"
                                    title={'Define a unidade padrão de saída'}
                                    text="Unidade Saída"
                                    inputWidth="200px"
                                    options={optionsUnidade}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.unidadeSaidaId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros de movimentações de serviço</h4>
                            <div>
                                <DataList
                                    title="NCM padrão para Imóvel"
                                    text="NCM Imóvel"
                                    name="ncmImovel.descricao"
                                    inputWidth="350px"
                                    filteredOptions={OptionsNcmImovel}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={ncmImovel.descricao || ''}
                                />
                                <DataList
                                    title="NCM padrão para serviço"
                                    text="NCM Serviço"
                                    name="ncmServico.descricao"
                                    inputWidth="350px"
                                    filteredOptions={OptionsNcmServico}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={ncmServico.descricao || ''}
                                />
                                <Select
                                    name="centroCustoLIM"
                                    title={'Define o centro de custo padrão para locação de imóveis'}
                                    text="Centro Custo LIM"
                                    inputWidth="200px"
                                    options={OptionsCCLIM}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.centroCustoLIM}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <h4>Parâmetros de custos</h4>
                            <div>
                                <InputNumber
                                    name="horasMensais"
                                    title={'Define a quentidade de horas mensais trabalhadas, valor padrão 220'}
                                    text="Horas Mensais"
                                    inputWidth={'100px'}
                                    textAlign="center"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.horasMensais}
                                />
                                <InputNumber
                                    name="horasMensaisCustoFixo"
                                    title={
                                        'Define a quentidade de horas mensais para cálculo de custo fixo de colaboradores, valor padrão 720'
                                    }
                                    text="Horas Custo Fixo"
                                    inputWidth={'100px'}
                                    textAlign="center"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.horasMensaisCustoFixo}
                                />
                                <InputNumber
                                    name="horaExtraPercentual"
                                    title={'Define o percentual de acréscimo de hora extra'}
                                    text="Hora Extra %"
                                    inputWidth={'100px'}
                                    textAlign="right"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.horaExtraPercentual ? formatarNumero(dados.horaExtraPercentual) : ''}
                                />
                                <InputNumber
                                    name="horaExtraEspecialPercentual"
                                    title={'Define o percentual de acréscimo de hora extra aos domingos e feriados'}
                                    text="Hora Extra Especial %"
                                    inputWidth={'150px'}
                                    textAlign="right"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={
                                        dados.horaExtraEspecialPercentual ? formatarNumero(dados.horaExtraEspecialPercentual) : ''
                                    }
                                />
                                <Input
                                    type={'time'}
                                    name="adicionalNoturnoInicio"
                                    title={'Define a hora de inicio a contar adicional noturno'}
                                    text="Adic. Noturno Início"
                                    inputWidth={'150px'}
                                    textAlign="right"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.adicionalNoturnoInicio}
                                />
                                <Input
                                    type={'time'}
                                    name="adicionalNoturnoTermino"
                                    title={'Define a hora de término da contagem de adicional noturno'}
                                    text="Adic. Noturno Término"
                                    inputWidth={'150px'}
                                    textAlign="right"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.adicionalNoturnoTermino}
                                />
                                <InputNumber
                                    name="adicionalNoturnoPercentual"
                                    title={'Define o percentual de acréscimo de hora trabalhada em adicional noturno'}
                                    text="Adic. Noturno %"
                                    inputWidth={'100px'}
                                    textAlign="right"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={
                                        dados.adicionalNoturnoPercentual ? formatarNumero(dados.adicionalNoturnoPercentual) : ''
                                    }
                                />
                                <InputNumber
                                    name="adicionalNoturnoEspecialPercentual"
                                    title={
                                        'Define o percentual de acréscimo de hora trabalhada em adicional noturno as domingos e feriados'
                                    }
                                    text="Adic. Noturno Especial %"
                                    inputWidth={'150px'}
                                    textAlign="right"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={
                                        dados.adicionalNoturnoEspecialPercentual
                                            ? formatarNumero(dados.adicionalNoturnoEspecialPercentual)
                                            : ''
                                    }
                                />
                                <Checkbox
                                    title="quando marcado os indexadores ficam vinculados a empresa, quando não os indexadores ficam globais para todas as empresas, lembrar que ao marcar essa opção a empresa deverá ter os indexadores, essa configuração se aplica quando o sistema possue multi empresa, caso contrário não tem efeito"
                                    text="indexador"
                                    name="indexadorMonoEmpresa"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.indexadorMonoEmpresa}
                                    checked={!!dados.indexadorMonoEmpresa}
                                />
                                <Checkbox
                                    title="Considera o custo do pessoal de expediente no plantão"
                                    text="Expediente"
                                    name="consideraExpedienteNoPlantao"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.consideraExpedienteNoPlantao}
                                    checked={!!dados.consideraExpedienteNoPlantao}
                                />
                            </div>
                            <h4>Parâmetros de expedientes</h4>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <Select
                                    name="novoExpediente.diaSemana"
                                    text="Dia"
                                    options={[
                                        { id: 0, descricao: 'Domingo' },
                                        { id: 1, descricao: 'Segunda' },
                                        { id: 2, descricao: 'Terça' },
                                        { id: 3, descricao: 'Quarta' },
                                        { id: 4, descricao: 'Quinta' },
                                        { id: 5, descricao: 'Sexta' },
                                        { id: 6, descricao: 'Sábado' },
                                    ]}
                                    handleOnChange={handleChange}
                                    value={novoExpediente.diaSemana ?? ''}
                                    isEnum={false}
                                    notOptNull={false}
                                />

                                <Input
                                    type="time"
                                    name="novoExpediente.inicio"
                                    text="Início"
                                    handleOnChange={handleChange}
                                    value={novoExpediente.inicio}
                                />

                                <Input
                                    type="time"
                                    name="novoExpediente.termino"
                                    text="Término"
                                    handleOnChange={handleChange}
                                    value={novoExpediente.termino}
                                />

                                <Checkbox
                                    text="Desc Intervalo"
                                    name="novoExpediente.descontaIntervalo"
                                    handleOnChange={handleChange}
                                    checked={!!novoExpediente.descontaIntervalo}
                                />

                                <Input
                                    type="time"
                                    name="novoExpediente.intervaloInicio"
                                    text="Intervalo Início"
                                    handleOnChange={handleChange}
                                    value={novoExpediente.intervaloInicio}
                                />

                                <Input
                                    type="time"
                                    name="novoExpediente.intervaloTermino"
                                    text="Intervalo Término"
                                    handleOnChange={handleChange}
                                    value={novoExpediente.intervaloTermino}
                                />

                                <Checkbox
                                    text="Ativo"
                                    name="novoExpediente.ativo"
                                    handleOnChange={handleChange}
                                    checked={!!novoExpediente.ativo}
                                />
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        handleLimpar('expediente');
                                    }}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    Limpar
                                </Button>
                                <Button
                                    variant="contained"
                                    color={'info'}
                                    onClick={() => {
                                        handleObjeto('expediente');
                                    }}
                                    disabled={!novoExpediente.parametroId || !novoExpediente.diaSemana}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    {novoExpediente.funcao}
                                </Button>
                            </div>
                            <div>
                                <ThemeProvider theme={theme}>
                                    <MaterialReactTable
                                        displayColumnDefOptions={{
                                            'mrt-row-actions': {
                                                muiTableHeadCellProps: {
                                                    align: 'center',
                                                },
                                                size: 100,
                                            },
                                            'mrt-row-numbers': {
                                                enableColumnOrdering: true, //turn on some features that are usually off
                                                enableResizing: true,
                                                muiTableHeadCellProps: {
                                                    sx: {
                                                        fontSize: '1.2rem',
                                                    },
                                                },
                                            },
                                            'mrt-row-select': {
                                                enableColumnActions: true,
                                                enableHiding: true,
                                                size: 50,
                                            },
                                        }}
                                        enableColumnFilterModes
                                        enableGlobalFilterModes
                                        enableEditing
                                        renderRowActions={({ row, table }) => (
                                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                                <Tooltip arrow placement="top" title={'Editar'}>
                                                    <span>
                                                        {' '}
                                                        <IconButton
                                                            onClick={() => {
                                                                handleItem(row.original, row.index, 'Editar', 'expediente');
                                                            }}
                                                            disabled={localStorage.getItem('editar') === 'true' ? false : true}
                                                        >
                                                            {<Edit />}
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Box>
                                        )}
                                        columns={columnsExpediente}
                                        data={dados.expedientes || []}
                                        rowCount={expedienteMrt.rowCount}
                                        getRowId={(row) => row.id}
                                        //manualFiltering
                                        manualPagination
                                        manualSorting
                                        muiToolbarAlertBannerProps={
                                            expedienteMrt.isError
                                                ? {
                                                      color: 'error',
                                                      children: 'Error loading data',
                                                  }
                                                : undefined
                                        }
                                        onColumnFiltersChange={expedienteMrt.setColumnFilters}
                                        onColumnFilterFnsChange={expedienteMrt.setColumnFiltersMode}
                                        onGlobalFilterChange={expedienteMrt.setGlobalFilter}
                                        onPaginationChange={expedienteMrt.setPagination}
                                        onSortingChange={expedienteMrt.setSorting}
                                        initialState={{
                                            showColumnFilters: true,
                                            density: 'compact',
                                            //columnPinning: { left: ["mrt-row-select"] },
                                        }}
                                        state={{
                                            columnFilterFns: expedienteMrt.columnFilterFns,
                                            columnFilters: expedienteMrt.columnFilters,
                                            globalFilter: expedienteMrt.globalFilter,
                                            isLoading: expedienteMrt.isLoading,
                                            pagination: expedienteMrt.pagination,
                                            showAlertBanner: expedienteMrt.isError,
                                            showProgressBars: expedienteMrt.isRefetching,
                                            sorting: expedienteMrt.sorting,
                                        }}
                                        //positionToolbarDropZone={"top"}
                                        positionExpandColumn={'first'}
                                        positionActionsColumn={'first'}
                                        positionToolbarAlertBanner="bottom"
                                        localization={MRT_Localization_PT_BR}
                                    />
                                </ThemeProvider>
                            </div>
                            <h4>Parâmetros de operações custos</h4>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <Select
                                    name="novaOperacaoCusto.operacaoId"
                                    title={'Define a operação vinculada ao custo'}
                                    text="Operação"
                                    options={OptionsOperacao}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novaOperacaoCusto.operacaoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="novaOperacaoCusto.plantaoTipoId"
                                    title={'Define o tipo de plantão vinculado a operação de custo'}
                                    text="Plantão tipo"
                                    options={OptionsPlantaoTipo}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novaOperacaoCusto.plantaoTipoId}
                                    isEnum={false}
                                    notOptNull={false}
                                />

                                <Checkbox
                                    title="Custo quando marcado"
                                    text="Custo"
                                    name="novaOperacaoCusto.custo"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novaOperacaoCusto.custo}
                                    checked={!!novaOperacaoCusto.custo}
                                />
                                <Checkbox
                                    title="Receita quando marcado"
                                    text="Receita"
                                    name="novaOperacaoCusto.receita"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novaOperacaoCusto.receita}
                                    checked={!!novaOperacaoCusto.receita}
                                />
                                <Checkbox
                                    title="Ativo quando marcado"
                                    text="Ativo"
                                    name="novaOperacaoCusto.ativo"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novaOperacaoCusto.ativo}
                                    checked={!!novaOperacaoCusto.ativo}
                                />
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        handleLimpar('custo');
                                    }}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    Limpar
                                </Button>
                                <Button
                                    variant="contained"
                                    color={novaOperacaoCusto.funcao?.toLowerCase() === 'cancelar' ? 'error' : 'info'}
                                    onClick={() => {
                                        handleObjeto('custo');
                                    }}
                                    disabled={
                                        novaOperacaoCusto.funcao !== 'cancelar' &&
                                        (!novaOperacaoCusto.operacaoId || !novaOperacaoCusto.plantaoTipoId)
                                    }
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    {novaOperacaoCusto.funcao}
                                </Button>
                            </div>
                            <div>
                                <ThemeProvider theme={theme}>
                                    <MaterialReactTable
                                        displayColumnDefOptions={{
                                            'mrt-row-actions': {
                                                muiTableHeadCellProps: {
                                                    align: 'center',
                                                },
                                                size: 100,
                                            },
                                            'mrt-row-numbers': {
                                                enableColumnOrdering: true, //turn on some features that are usually off
                                                enableResizing: true,
                                                muiTableHeadCellProps: {
                                                    sx: {
                                                        fontSize: '1.2rem',
                                                    },
                                                },
                                            },
                                            'mrt-row-select': {
                                                enableColumnActions: true,
                                                enableHiding: true,
                                                size: 50,
                                            },
                                        }}
                                        enableColumnFilterModes
                                        enableGlobalFilterModes
                                        //enableColumnResizing
                                        enableColumnOrdering
                                        enableEditing
                                        renderRowActions={({ row, table }) => (
                                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                                <Tooltip arrow placement="top" title={'Editar'}>
                                                    <span>
                                                        {' '}
                                                        <IconButton
                                                            onClick={() => {
                                                                handleItem(row.original, row.index, 'Editar', 'custo');
                                                            }}
                                                            disabled={localStorage.getItem('editar') === 'true' ? false : true}
                                                        >
                                                            {<Edit />}
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                                <Tooltip arrow placement="right" title="Cancelar">
                                                    <span>
                                                        <IconButton
                                                            color="error"
                                                            onClick={() => handleItem(row.original, row.id, 'Cancelar', 'custo')}
                                                            disabled={localStorage.getItem('editar') === 'true' ? false : true}
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Box>
                                        )}
                                        columns={columnsCusto}
                                        data={parametroOperacaoCustos}
                                        rowCount={custoMrt.rowCount}
                                        getRowId={(row) => row.uuid}
                                        //manualFiltering
                                        manualPagination
                                        manualSorting
                                        muiToolbarAlertBannerProps={
                                            custoMrt.isError
                                                ? {
                                                      color: 'error',
                                                      children: 'Error loading data',
                                                  }
                                                : undefined
                                        }
                                        onColumnFiltersChange={custoMrt.setColumnFilters}
                                        onColumnFilterFnsChange={custoMrt.setColumnFiltersMode}
                                        onGlobalFilterChange={custoMrt.setGlobalFilter}
                                        onPaginationChange={custoMrt.setPagination}
                                        onSortingChange={custoMrt.setSorting}
                                        initialState={{
                                            showColumnFilters: true,
                                            density: 'compact',
                                            //columnPinning: { left: ["mrt-row-select"] },
                                        }}
                                        state={{
                                            columnFilterFns: custoMrt.columnFilterFns,
                                            columnFilters: custoMrt.columnFilters,
                                            globalFilter: custoMrt.globalFilter,
                                            isLoading: custoMrt.isLoading,
                                            pagination: custoMrt.pagination,
                                            showAlertBanner: custoMrt.isError,
                                            showProgressBars: custoMrt.isRefetching,
                                            sorting: custoMrt.sorting,
                                        }}
                                        //positionToolbarDropZone={"top"}
                                        positionExpandColumn={'first'}
                                        positionActionsColumn={'first'}
                                        positionToolbarAlertBanner="bottom"
                                        localization={MRT_Localization_PT_BR}
                                    />
                                </ThemeProvider>
                            </div>
                        </div>
                    </TabPanel>
                    <div>
                        <Stack direction="row" spacing={1}>
                            <Tooltip arrow placement="top-start" title="Voltar">
                                <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar, params)}>
                                    Voltar
                                </Button>
                            </Tooltip>
                            <Button type="submit" variant="contained" color="success" disabled={isSubmitting || isDisabled}>
                                {btnText}
                            </Button>
                        </Stack>
                    </div>
                </form>
            </Tabs>
        </div>
    );
}
export default Form;
